import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import Edit from "../../Assets/img/Edit.svg";
import Delete from "../../Assets/img/Delete.svg";
import dateIcon from "../../Assets/img/date.png";
import Search from "../../Assets/img/search.png";
import Search1 from "../../Assets/img/search-normal.png";
import Calendar from "../../Assets/img/calendar.png";
import "./News.css";
import Loading from "../../Loading/loading";
import { useLocation } from "react-router-dom";

const News = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [languageId, setLanguageId] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(1);

  const fetchCategories = (langId = languageId) => {
    API.post("newscategory_list/condition", { language_id: langId })
      .then((res) => {
        const categoryData = res?.data?.data?.data || [];
        const activeCategories = categoryData.filter(
          (cat) => cat.active === 1 || cat.active === "1"
        );
        setCategories(activeCategories);
      })
      .catch((err) => console.error("Failed to fetch categories:", err));
  };

  const fetchNews = () => {
    setLoading(true);
    API.post("news_list/condition", {
      language_id: languageId,
      search,
      status,
      from_date: fromDate,
      to_date: toDate,
      newscategory_id: category,
      rowsPerPage,
      page,
    })
      .then((res) => {
        const newsData = res?.data?.data?.data || [];
        const totalCount =
          res?.data?.data?.data1?.[0]?.totalcount || newsData.length;

        setNews(newsData);
        setTotalPages(Math.ceil(totalCount / rowsPerPage));
      })
      .catch((err) => console.error("Failed to fetch news:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchCategories(languageId);
    fetchNews();
  }, [languageId, page]);

  const handleToggleStatus = (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    API.post("news_status/update", { news_id: id, status: newStatus })
      .then(() => fetchNews())
      .catch((err) => console.error("Failed to update status:", err));
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowPopup(true);
  };

  const confirmDelete = () => {
    if (!deleteId) return;
    API.post("news_delete/update", { news_id: deleteId, active: 4 })
      .then(() => {
        fetchNews();
        setShowPopup(false);
        setDeleteId(null);
      })
      .catch((err) => console.error("Failed to delete news:", err));
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleSearch = () => {
    setPage(1);
    localStorage.removeItem("newsPage");
    fetchNews();
  };
  useEffect(() => {
    if (location.state?.page) {
      setPage(location.state.page);

      // clear state AFTER restoring
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);
  return (
    <div className="news-container">
      <div className="category-header1">
        <h2 className="newss-title">News</h2>
        <button onClick={() => navigate("/newsadd")} className="add-btn">
          <strong>+</strong> Add News
        </button>
      </div>

      <div className="filter-rows">
        <div className="filter-block">
          <label>Search By</label>
          <div className="input-container">
            <input
              placeholder="Search by anything"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="input-field"
            />
            <img
              src={Search1}
              alt="Search"
              className="search-icon"
              onClick={fetchNews}
            />
          </div>
        </div>

        <div className="filter-block">
          <label>Status</label>
          <div className="input-container">
            <select
              onChange={(e) => setStatus(e.target.value)}
              value={status}
              className="input-field"
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="filter-block">
          <label>Category</label>
          <div className="input-container">
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="input-field"
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.newscategory_id} value={cat.newscategory_id}>
                  {cat.category_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="filter-block">
          <label>Language</label>
          <div className="input-container">
            <select
              onChange={(e) => {
                setLanguageId(Number(e.target.value));
                setPage(1);
              }}
              value={languageId}
              className="input-field"
            >
              <option value="1">English</option>
              <option value="2">Français</option>
            </select>
          </div>
        </div>

        <div className="filter-btn-wrapper" onClick={handleSearch}>
          <img src={Search} alt="Filter" className="icon-btnf" />
        </div>
      </div>

      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="newss-grid">
            {news.length > 0 ? (
              news.map((item) => (
                <div key={item.news_id} className="newss-card">
                  <div className="cards-footer">
                    <div className="status-container">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item.status === "active"}
                          onChange={() =>
                            handleToggleStatus(item.news_id, item.status)
                          }
                        />
                        <span className="slider round">
                          <span className="switch-label">
                            {item.status === "active" ? "ON" : "OFF"}
                          </span>
                        </span>
                      </label>
                      <span className="status-text-news">
                        {categories.find(
                          (cat) =>
                            Number(cat.newscategory_id) ===
                            Number(item.newscategory_id)
                        )?.category_name || "Unknown"}
                      </span>
                    </div>

                    <div className="action-buttons">
                      <img
                        src={Edit}
                        alt="Edit"
                        className="edit-icon-btn"
                        onClick={() =>
                          navigate(`/newsedit/${item.news_id}`, { state: { news: item, page } })

                        }
                      />
                      <img
                        src={Delete}
                        alt="Delete"
                        className="edit-icon-btn"
                        onClick={() => handleDeleteClick(item.news_id)}
                      />
                    </div>
                  </div>

                  <div className="date-tag">
                    <img src={dateIcon} alt="Date" className="date-icon" />
                    <span>{item.date}</span>
                  </div>

                  <h3
                    className="newss-heading clickable-title"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/newsview/${item.news_id}`, { state: { news: item, page } });
                    }}
                  >
                    {item.heading}
                  </h3>

                  <div
                    className="newss-description clickable-description"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/newsview/${item.news_id}`, { state: { news: item, page } });
                    }}
                    dangerouslySetInnerHTML={{
                      __html: item.description.replace(/<[^>]+>/g, ''),
                    }}
                  ></div>
                </div>
              ))
            ) : (
              <p className="no-news-text">No news found.</p>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <button
                className="pagination-btn"
                onClick={handlePrev}
                disabled={page === 1}
              >
                Prev
              </button>


              {(() => {
                const pageNumbers = [];
                const maxVisible = 5;

                if (totalPages <= maxVisible) {

                  for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
                } else {
                  if (page <= 3) {
                    pageNumbers.push(1, 2, 3, "...", totalPages);
                  } else if (page >= totalPages - 2) {
                    pageNumbers.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
                  } else {
                    pageNumbers.push(1, "...", page - 1, page, page + 1, "...", totalPages);
                  }
                }

                return pageNumbers.map((num, index) =>
                  num === "..." ? (
                    <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                      ...
                    </span>
                  ) : (
                    <button
                      key={num}
                      className={`pagination-btn ${page === num ? "active" : ""}`}
                      onClick={() => setPage(num)}
                    >
                      {num}
                    </button>
                  )
                );
              })()}
              <button
                className="pagination-btn"
                onClick={handleNext}
                disabled={page === totalPages}
              >
               Next
              </button>
            </div>
          )}
        </>
      )}

      {/* Delete Confirmation Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this News?</p>
            <div className="popup-buttons">
              <button
                className="cancel-btn "
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>
              <button className="btn delete-btn" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
